import { useLocation, useNavigate } from 'react-router-dom'
import {
  FormatListBulletedRounded,
  GridViewRounded,
  Insights,
  TimerOutlined,
} from '@mui/icons-material'
import { Button } from '@mui/material'
import { useTask } from '@hooks'
import './menu.style.scss'

const style = {
  borderRadius: 5,
  margin: 0.4,
  width: 60,
  minWidth: 60,
  height: 60,
  boxShadow: 'none',
  '@media screen and (orientation: portrait)': {
    borderRadius: 4,
    width: 'clamp(42px, 5.4vmin, 56px)',
    minWidth: 'clamp(42px, 5.4vmin, 56px)',
    height: 'clamp(42px, 5.4vmin, 56px)',
  },
}

const Menu = ({ className = '' }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { getTasks } = useTask()

  const isActive = path => location.pathname === path
  const tasksMatrix = getTasks()
  const totalTasks = Object.values(tasksMatrix).reduce(
    (total, taskGroup) => total + taskGroup.length,
    0
  )
  const showTaskHint = location.pathname === '/matriz' && totalTasks === 0

  const renderButtons = () => (
    <>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={style}
        color={isActive('/') ? 'secondary' : 'primary'}
      >
        {<TimerOutlined className="pomodoro__icon" />}
      </Button>

      <div className="menu__button-wrapper">
        {showTaskHint && (
          <div className="menu__hint">
            <div className="menu__hint__arrow" />
            <strong>Crie uma tarefa</strong>
            <p>
              Cadastre uma tarefa na lista e depois volte para organizar na
              matriz.
            </p>
          </div>
        )}
        <Button
          variant="contained"
          onClick={() => navigate('/tarefas')}
          sx={style}
          color={isActive('/tarefas') ? 'secondary' : 'primary'}
        >
          {<FormatListBulletedRounded className="list__icon" />}
        </Button>
      </div>

      <Button
        variant="contained"
        onClick={() => navigate('/matriz')}
        sx={style}
        color={isActive('/matriz') ? 'secondary' : 'primary'}
      >
        {<GridViewRounded className="matrix__icon" />}
      </Button>

      <Button
        variant="contained"
        onClick={() => navigate('/relatorio')}
        sx={style}
        color={isActive('/relatorio') ? 'secondary' : 'primary'}
      >
        {<Insights className="graphic__icon" />}
      </Button>
    </>
  )

  return <aside className={`menu ${className}`.trim()}>{renderButtons()}</aside>
}

export { Menu }
